// extracted by mini-css-extract-plugin
module.exports = {"simulatorInput":"MoneyInput_simulatorInput__37Gdl","input":"MoneyInput_input__9LAwH"};